import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=48ff3ca9&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=ts"
export * from "./UserMenu.vue?vue&type=script&lang=ts"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=48ff3ca9&prod&scoped=true&lang=sass"
import style1 from "./UserMenu.vue?vue&type=style&index=1&id=48ff3ca9&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ff3ca9",
  null
  
)

export default component.exports